<!--
 * @Author: wumao
 * @Date: 2021-11-24 16:15:02
 * @LastEditors: yeqing
 * @LastEditTime: 2022-05-13 11:12:04
 * @Description: 第一页
-->
<template>
  <Page page="02" :companyName="resultData.orgName">
    <div class="wrapper">
      <div class="item">
        <Title text="海南省专精特新中小企业分布情况" />
        <div class="info">
          <img src="@/assets/images/hainan.png" />
          <div class="img-title">海南省专精特新中小企业总数 138家</div>
          <div class="img-desc">
            <span>三亚市 10家</span>
            <span>儋州市 8家</span>
            <span>海口市 99家</span>
            <span>三沙市 1家</span>
            <span>省直辖县级行政区划 20家</span>
          </div>
        </div>
      </div>
    </div>
  </Page>
</template>

<script>
import Page from "./Page.vue";
import Title from "./Title.vue";
export default {
  props: {
    resultData: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    Page,
    Title,
  },
};
</script>

<style lang="less" scoped>
.wrapper {
  .item {
    font-size: 14px;
    color: #333;
    margin-bottom: 30px;
    .info {
      margin-left: 20px;
      margin-top: 30px;
      line-height: 25px;
      img {
        width: 400px;
        height: auto;
        margin: 0 auto;
        display: block;
      }
      .img-title {
        height: 16px;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
        line-height: 24px;
        margin-top: 27px;
        text-align: center;
      }
      .img-desc {
        height: 16px;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        line-height: 24px;
        margin-top: 13px;
        text-align: center;
       display: flex;
       justify-content: space-around;
      }
    }
  }
}
</style>
